import { useQuery } from "@tanstack/react-query";
import { listDelegationHistory } from "../../api/delegation";
import { delegationQueryKeys } from "./delegationQueryKeys";

export const useDelegationHistory = (enabled = true) =>
  useQuery({
    queryKey: delegationQueryKeys.history,
    queryFn: listDelegationHistory,
    enabled,
  });
